import React from "react";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import BasicButton from "../../SharedComponents/BasicButton/BasicButton";
import BasicCheckbox from "../../SharedComponents/BasicCheckbox/BasicCheckbox";
import BasicTextField from "../../SharedComponents/BasicTextField/BasicTextField";
import { adhocReportColumnCatalog } from "./config";
import "./AdHocColumnPickerModal.scss";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "90%",
    maxWidth: 720,
    maxHeight: "85vh",
    overflow: "auto",
    backgroundColor: "#fff",
    border: "2px solid grey",
    borderRadius: "8px",
    padding: "1rem",
  },
}));

const GROUP_LABELS = {
  standard: "Standard columns",
  rights: "Rights & fees",
  flags: "Song / clearance flags",
};

const AdHocColumnPickerModal = ({
  open,
  draftColumns,
  searchText,
  onSearchChange,
  onToggleColumn,
  onSelectAll,
  onResetDefault,
  onApply,
  onClose,
}) => {
  const classes = useStyles();
  const selectedValues = new Set((draftColumns || []).map((column) => column.value));
  const normalizedSearch = (searchText || "").trim().toLowerCase();

  const filteredCatalog = adhocReportColumnCatalog.filter((column) => {
    if (!normalizedSearch) return true;
    return column.label.toLowerCase().includes(normalizedSearch);
  });

  const groupedColumns = filteredCatalog.reduce((groups, column) => {
    const groupKey = column.group || "standard";
    if (!groups[groupKey]) groups[groupKey] = [];
    groups[groupKey].push(column);
    return groups;
  }, {});

  return (
    <Modal open={open} onClose={onClose} className={classes.modal}>
      <div className={`${classes.paper} adhoc-column-picker-modal`}>
        <div className="adhoc-column-picker-header">
          <h6><b>Choose Report Columns</b></h6>
          <span className="adhoc-column-picker-count">{draftColumns?.length || 0} selected</span>
        </div>
        <p className="adhoc-column-picker-help">
          Selected columns appear left-to-right in the exported report.
        </p>
        <div className="adhoc-column-picker-toolbar">
          <BasicTextField
            value={searchText || ""}
            placeholder="Search columns"
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <BasicButton variant="outlined" text="Select All" onClick={onSelectAll} />
          <BasicButton variant="outlined" text="Reset Default" onClick={onResetDefault} />
        </div>
        {Object.keys(GROUP_LABELS).map((groupKey) => {
          const columns = groupedColumns[groupKey];
          if (!columns?.length) return null;
          return (
            <div key={groupKey} className="adhoc-column-picker-group">
              <p className="adhoc-column-picker-group-label">{GROUP_LABELS[groupKey]}</p>
              <div className="adhoc-column-picker-grid">
                {columns.map((column) => (
                  <BasicCheckbox
                    key={column.value}
                    id={`adhoc-column-${column.value}`}
                    label={column.label}
                    checked={selectedValues.has(column.value)}
                    onChange={() => onToggleColumn(column)}
                  />
                ))}
              </div>
            </div>
          );
        })}
        <div className="adhoc-column-picker-actions">
          <BasicButton variant="outlined" text="Cancel" onClick={onClose} />
          <BasicButton
            variant="contained"
            text="Apply"
            onClick={onApply}
            disabled={!draftColumns?.length}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AdHocColumnPickerModal;
